import React from 'react';
import { Sunrise, Sun, Moon, Coffee } from 'lucide-react';
import { FoodThumbnail } from '@/components/FoodThumbnail';
import { C } from './dashboardConstants';

export const MealRow = ({ meal, onClick, token }) => {
  const t = meal.final_analysis?.totals || {};
  const items = meal.final_analysis?.items || [];
  const grade = meal.final_analysis?.health_score || null;
  const isGood = ['A+','A','A-','B+','B'].includes(grade);
  const itemNames = items.map(i => (i.name || '').replace(/\b\w/g, c => c.toUpperCase())).filter(Boolean);
  const description = itemNames.length > 0
    ? itemNames.length <= 2 ? itemNames.join(' & ') : `${itemNames.slice(0, 2).join(', ')} +${itemNames.length - 2}`
    : (meal.meal_type || 'Meal').replace(/\b\w/g, c => c.toUpperCase());
  const thumbFoodName = itemNames[0] || meal.meal_type || 'food';
  const mealType = meal.meal_type || 'snack';

  return (
    <div onClick={onClick} style={{
      display: 'flex', gap: 14, alignItems: 'center', padding: '14px 0',
      borderBottom: `1px solid ${C.borderLight}`, cursor: 'pointer',
    }} data-testid={`meal-row-${meal.meal_id}`}>
      <div style={{ position: 'relative', width: 52, height: 52, flexShrink: 0 }}>
        <FoodThumbnail
          foodName={thumbFoodName}
          thumbnailPath={meal.thumbnail_path}
          mealId={meal.meal_id}
          token={token}
          size="md"
        />
        {grade && (
          <div style={{
            position: 'absolute', bottom: -4, right: -4,
            width: 24, height: 24, borderRadius: 7,
            background: isGood ? C.greenBg : C.goldBg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 9, fontWeight: 700, color: isGood ? C.green : '#D4880F',
            fontFamily: 'var(--font-sans)', border: '2px solid #FDFBF7',
          }}>{grade}</div>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 14, margin: 0, fontWeight: 500, color: C.text, fontFamily: 'var(--font-sans)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {description}
        </p>
        <p style={{ fontSize: 12, margin: '3px 0 0', color: C.muted, fontFamily: 'var(--font-sans)' }}>
          {Math.round(t.calories || 0)} cal · {Math.round(t.protein || 0)}g protein
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
        {mealType === 'breakfast' && <Sunrise style={{ width: 14, height: 14, color: C.gold }} />}
        {mealType === 'lunch' && <Sun style={{ width: 14, height: 14, color: C.gold }} />}
        {mealType === 'dinner' && <Moon style={{ width: 14, height: 14, color: C.purple }} />}
        {mealType === 'snack' && <Coffee style={{ width: 14, height: 14, color: C.accent }} />}
        <span style={{ fontSize: 11, color: C.muted, fontFamily: 'var(--font-sans)', textTransform: 'capitalize' }}>
          {mealType}
        </span>
      </div>
    </div>
  );
};
